import axios from 'axios'
import {setupAxios, UserModel} from '../app/modules/auth'
import {API_BASE_URL} from '../utils/contants'
import {api} from './APIMiddlewares'
import API from './APIUrl'

export async function getLeaveReasons(leaveTypeId: string) {
  const {token, tenantId} = setupAxios()
  return await api.get(`/leave-reasons?leaveTypeId=${leaveTypeId}`, token, tenantId, false)
}

export async function addLeave(inputField: {
  sender: string
  recipients: {
    to: string
    cc: string[]
  }
  leaveType: string
  reason: string
  reasonId: string
  description?: string
  attachment: File | null
  leaveDate: {
    startDate: string
    endDate: string
    type: string
    startTime?: string
    endTime?: string
  }[]
}) {
  const {token, id, tenantId} = setupAxios()

  // const leaveUser = [
  //   ...inputField.recipients.to.map((receiver) => ({type: 'to', receiver: {id: receiver}})),
  //   ...inputField.recipients.cc.map((receiver) => ({type: 'cc', receiver: {id: receiver}})),
  // ]
  const leaveDate = inputField?.leaveDate?.map((item) => item)[0]
  
  // Map the frontend type values to backend enum values
  const mapLeaveDuration = (type: string) => {
    switch (type?.toLowerCase()) {
      case 'full':
        return 'FULL'
      case 'first_half':
      case 'firsthalf':
        return 'FIRST_HALF'
      case 'second_half':
      case 'secondhalf':
        return 'SECOND_HALF'
      default:
        return 'FULL'
    }
  }

  // Map the correct reason/description field based on leave type
  const isValidUUID = (str: string) => {
    const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
    return uuidRegex.test(str);
  };

  // Helper function to get default reasonId for leave types
  const getDefaultReasonForLeaveType = async (leaveTypeId: string): Promise<string | null> => {
    try {
      const response = await getLeaveReasons(leaveTypeId);
      if (response.statusCode === 200 && response.data && response.data.length > 0) {
        return response.data[0].id; // Return first available reason as default
      }
    } catch (error) {
      console.error('Error fetching leave reasons:', error);
    }
    return null;
  };

  // Ensure we always have content for the reason field
  // Use whichever field has content (reason or description)
  const reasonText = inputField.reason?.trim() || inputField.description?.trim() || '';
  const descriptionText = inputField.description?.trim() || inputField.reason?.trim() || '';

  // Determine if reasonId is needed and get it if missing
  let finalReasonId = inputField.reasonId;
  
  // If no reasonId provided but we have a leaveType, try to get default reasonId
  if (!finalReasonId || !isValidUUID(finalReasonId)) {
    try {
      const defaultReasonId = await getDefaultReasonForLeaveType(inputField.leaveType);
      if (defaultReasonId) {
        finalReasonId = defaultReasonId;
      }
    } catch (error) {
      console.error('Error getting default reason:', error);
    }
  }


  const emailData: any = {
    userId: id,
    toUserId: inputField?.recipients?.to,
    ccUserId: inputField?.recipients?.cc,
    leaveTypeId: inputField?.leaveType,
    leaveDuration: mapLeaveDuration(leaveDate?.type),
    startDate: leaveDate?.startDate,
    endDate: leaveDate?.endDate,
    reason: reasonText,
    description: descriptionText,
  }

  // Only add reasonId if it's a valid UUID
  if (finalReasonId && isValidUUID(finalReasonId)) {
    emailData.reasonId = finalReasonId;
  }

  let formData = new FormData()
  if (inputField?.attachment) formData.append('attachment', inputField.attachment)
  formData.append('userId', id)
  formData.append('toUserId', inputField?.recipients?.to ?? '')
  formData.append('leaveTypeId', inputField?.leaveType ?? '')
  formData.append('leaveDuration', mapLeaveDuration(leaveDate?.type) ?? 'FULL')
  formData.append('startDate', leaveDate?.startDate ?? '')
  formData.append('endDate', leaveDate?.endDate ?? '')
  formData.append('reason', reasonText)
  formData.append('description', descriptionText)
  
  // Only add reasonId if it's a valid UUID
  if (finalReasonId && isValidUUID(finalReasonId)) {
    formData.append('reasonId', finalReasonId);
  } else {
  }
  if (inputField?.recipients?.cc?.length > 0) {
    let ccIds = ''
    inputField?.recipients?.cc?.map(
      (item, index) => {}
      // index + 1 !== inputField?.recipients?.cc?.length ? ccIds + item + ', ' : ccIds + item
    )
    formData.append('ccUserId', inputField?.recipients?.cc?.toString())
  }
  return await api.post(
    `/${API.LEAVEREQUEST}`,
    token,
    tenantId,
    {
      body: formData,
    },
    false,
    true
  )
}

export async function getLeaveEmails(userId, action, options?: {
  page?: number
  pageSize?: number
  status?: string
  search?: string
  applicantId?: string
  leaveId?: string
}) {
  const {token, tenantId} = setupAxios()
  const params = new URLSearchParams({userType: action, userId})
  if (options?.page !== undefined) params.set('page', String(options.page))
  if (options?.pageSize !== undefined) params.set('pageSize', String(options.pageSize))
  if (options?.status) params.set('status', options.status)
  if (options?.search) params.set('search', options.search)
  if (options?.applicantId) params.set('applicantId', options.applicantId)
  if (options?.leaveId) params.set('leaveId', options.leaveId)
  return await api.get(
    `/${API.LEAVEREQUEST}?${params.toString()}`,
    token,
    tenantId,
    false
  )
}
export async function getLeavesBalance(userId) {
  const {token, tenantId} = setupAxios()
  
  try {
    // Use the new dynamic balance endpoint that calculates balances based on current policies
    const response = await api.get(`/leave-balance/dynamic/user?userId=${userId}`, token, tenantId, false);
    
    if (response.statusCode === 200) {
      return response;
    } else {
      console.warn('Dynamic leave balance fetch returned non-200 status:', response.statusCode);
      return response;
    }
  } catch (error) {
    console.error('Error fetching dynamic leave balances:', error);
    return {
      statusCode: 500,
      message: 'Failed to fetch dynamic leave balances',
      data: []
    };
  }
}

export async function updateLeaveBalancesOnPolicyChange(employmentTypeId?: string, leaveTypeId?: string) {
  const {token, tenantId} = setupAxios()
  
  const queryParams = new URLSearchParams();
  if (employmentTypeId) queryParams.append('employmentTypeId', employmentTypeId);
  if (leaveTypeId) queryParams.append('leaveTypeId', leaveTypeId);
  
  try {
    const response = await api.post(
      `/leave-balance/update-on-policy-change?${queryParams.toString()}`, 
      token, 
      tenantId, 
      {}, 
      false
    );
    return response;
  } catch (error) {
    console.error('Error updating balances on policy change:', error);
    return {
      statusCode: 500,
      message: 'Failed to update leave balances on policy change',
      data: null
    };
  }
}
export async function getPieChartDatas(userId) {
  const {token, tenantId} = setupAxios()
  return await api.get(`/pie-chart/user/${userId}`, token, tenantId, false)
}

export async function cancelLeave(leaveId, currentUser) {
  const {token, tenantId} = setupAxios()
  return await api.put(
    `${API_BASE_URL}/leave/${leaveId}/status`,
    token,
    tenantId,
    {
      body: JSON.stringify({
        status: 'cancel',
        approvedBy: {
          id: currentUser.id,
        },
      }),
    },
    false
  )
}
export async function getallUsersLeaves() {
  const {token, tenantId} = setupAxios()
  return await api.get(`/leaveBalance`, token, tenantId, false)
}

export async function getLeaveBalancesById(id: string) {
  const {token, tenantId} = setupAxios()
  return await api.get(`/leaveBalance/${id}`, token, tenantId, false)
}
export async function updateLeaveBalanceById(
  InputField: {
    leaveType: string
    leaveDate: {
      startDate: string
      endDate: string
      type: string
      approvedBy: {
        id: string
      }
      sender: {
        id: string
      }
    }
  },
  id: string | null
) {
  const {token, tenantId} = setupAxios()
  return await api.put(
    `/leaveBalance/${id}`,
    token,
    tenantId,
    {
      body: JSON.stringify({
        leaveType: InputField.leaveType,
        leaveDate: {
          startDate: InputField.leaveDate.startDate,
          endDate: InputField.leaveDate.endDate,
          type: InputField.leaveDate.type,
        },
      }),
    },
    false
  )
}

export async function addManualLeave(
  InputField: {
    leaveType: string
    leaveDate: {
      startDate: string
      endDate: string
      type: string
      approvedBy: {
        id: string
      }
    }
    sender: {
      id: string
    }
  },
  editId,
  currentUser
) {
  const {token, tenantId} = setupAxios()
  return await api.post(
    `/manualLeaveEmail`,
    token,
    tenantId,
    {
      body: JSON.stringify({
        leaveType: InputField.leaveType,
        leaveDate: {
          startDate: InputField.leaveDate.startDate,
          endDate: InputField.leaveDate.endDate,
          type: InputField.leaveDate.type,
          approvedBy: {
            id: currentUser.id,
          },
        },
        sender: {
          id: editId,
        },
      }),
    },
    false
  )
}

export async function getFilterLeaves(userId, action) {
  const {token, tenantId} = setupAxios()
  return await api.get(`/user/${userId}/leavesForYear?action=${action}`, token, tenantId, false)
}

export const handleLeaveRejects = async (leaveId, currentUser) => {
  const {token, tenantId} = setupAxios()
  return await api.put(
    `/${API.LEAVEREQUEST}/${leaveId}/status`,
    token,
    tenantId,
    {
      body: JSON.stringify({
        status: 'REJECTED',
        remarks: 'Rejected',
        userId: currentUser.id,
      }),
    },
    false
  )
}
export const handleLeaveApproves = async (leaveId, currentUser) => {
  const {token, tenantId} = setupAxios()
  return await api.put(
    `/${API.LEAVEREQUEST}/${leaveId}/status`,
    token,
    tenantId,
    {
      body: JSON.stringify({
        status: 'APPROVED',
        remarks: 'Approved',
        userId: currentUser.id,
      }),
    },
    false
  )
}

export const handleLeaveAction = async (formField: {
  leaveId: string
  currentUser: UserModel | undefined
  status: string
  reason: string
  ignoreClValidation?: boolean
}) => {
  const {token, tenantId} = setupAxios()
  return await api.put(
    `/${API.LEAVEREQUEST}/${formField?.leaveId}/status`,
    token,
    tenantId,
    {
      body: JSON.stringify({
        status: formField?.status,
        remarks: formField?.reason,
        userId: formField?.currentUser?.id ?? '',
        ignoreClValidation: formField?.ignoreClValidation ?? false,
      }),
    },
    false
  )
}
